<span *ngIf="status" class="status-badge {{status}} {{fluid ? 'no-width' : ''}}">{{readableStatus}}</span>
<span *ngIf="!status">N/A</span>
